<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box search_box_f clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="合同日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="timestamp" format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="合同日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectsaleCostSeeList('brand_id')">
                    <el-option v-for="list in selectMapS.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectsaleCostSeeList('breed_id')">
                    <el-option v-for="list in selectMapS.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectsaleCostSeeList('grade_id')">
                    <el-option v-for="list in selectMapS.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.original_thickness" multiple collapse-tags placeholder="厚度" @visible-change="getSelectsaleCostSeeList('original_thickness')">
                    <el-option v-for="list in selectMapS.original_thickness" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_select search_inputBox" v-model="params.contract_no" placeholder="合同号" size="mini"></el-input>
                <el-input class="search_select search_inputBox" v-model="params.container_no" placeholder="货柜号" size="mini"></el-input>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="resetSearch">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="inventory.cost.list" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="inventory.cost.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
    </div>
</template>
<style scoped lang="scss">
</style>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    export default {
        components:{
            pagination,
            tabletem
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                params:{
                    start_time:"",
                    end_time:"",
                    container_no:"",
                    contract_no:"",
                    brand_id:[],
                    breed_id:[],
                    grade_id:[],
                    original_thickness:[],
                    per_page: 50,
                    page:1
                },
                start_time:"",
                end_time:"",
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                proList:[],
                cityList:[],
                searchCityList:[],
                selectMap:{
                    user:[],
                },
                selectMapS:{
                    supplier_id:[],
                    breed_id:[],
                    brand_id:[],
                    grade_id:[],
                    original_thickness:[]
                },
                // dialog
                dialogVisible : false,
                filterDialogVisible:false,
                filter:"",
                fields:"",
                tableCol:[	
                    {colName:"合同日期",colKey:"contract_time",colWidth:120,isSetWidth:true,isCanClick:false,isShow:true},
                    // {colName:"供应商",colKey:"supplier",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品牌",colKey:"brand",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"品名",colKey:"breed",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true}, 
                    {colName:"厚度",colKey:"original_thickness",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"合同号",colKey:"contract_no",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"货柜号",colKey:"container_no",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"外币单价",colKey:"foreign_currency_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"采购单价",colKey:"cube_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"费用平摊",colKey:"cost",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"成本单价",colKey:"cost_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"挂牌价",colKey:"sales_price",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"订单数量",colKey:"order_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"入库数量",colKey:"stock_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"已售数量",colKey:"sales_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"剩余数量",colKey:"last_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                ]
            }
        },
        created(){
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList();
        },
        methods:{
            excelExport(){
                this.$exportExecl("/erp/inventory.cost.export","成本查看",this.params)
            },
            filterConfirm(){
                this.getList()
            },
            getSelectsaleCostSeeList(target){
                this.$getSelectsaleCostSeeList(target,this.params).then(res=>{
                    this.selectMapS[res.data.data.target]=res.data.data.result;
                })
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time = this.formatTimeZero(this.start_time)
                this.params.end_time = this.formatTimeZero(this.end_time)
                this.tableLoading = true;
                this.$postColumnList("/erp/inventory.cost.list",this.params,res=>{
                    this.pl(res)
                    this.last_page=parseInt(res.data.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.data.total);
                    this.list=res.data.data.data.data;
                    this.list.forEach((item,index)=>{
                        if(item.contract_time!=0){
                            this.list[index].contract_time = this.formatTime(item.contract_time+"000")
                        }else{
                            this.list[index].contract_time = "";
                        }
                    })
                    this.filter = res.data.data.column;
                    this.fields=","+(res.data.data.fields.join(",")).toString()+",";
                    this.tableCol.forEach(item=>{
                        if(this.fields.indexOf(","+item.colKey+",")!=-1){
                            item.isShow=true;
                        }else{
                            item.isShow=false;
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            resetSearch(){
                this.params = this.params = {
                    start_time:"",
                    end_time:"",
                    container_no:"",
                    contract_no:"",
                    brand_id:[],
                    breed_id:[],
                    grade_id:[],
                    original_thickness:[],
                    per_page: 50,
                    page:1
                }
                this.start_time = "";
                this.end_time = "";
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
        },
        watch:{
            dialogVisible:function(val){
                if(!val){
                    this.form_params = this.resetJson(this.form_params)
                }
            },
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            }
        }
    }
</script>
